module.exports = __webpack_public_path__ + "img/att_hz_lg_lkp_rgb_wht.1877d046.png";